<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" epub:type="prologue" id="prologue" role="doc-prologue">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PROLOGUE</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-i"><span class="drop-cap">I</span>’ve always wanted to live by the sea.</p>
<p class="subsq">Ever since I was little and my mother used to take me to the beach at Lyme Regis and we’d get cones of chips and ice cream with 99s for after.</p>
<p class="subsq">The smell of the fresh salty air, the cries of the seagulls warping gently in the wind, the smiles on people’s faces as they splash about in the water, the hulls of the fishing boats as they sit lopsided at low tide, my mum lovingly applying the coconut lotion to my red shoulders after I spent too much time in the sun…</p>
<p class="subsq">Yep, there’s something undeniably magical about the sea. Especially since my father wasn’t there.</p>
<p class="subsq">When you are young you don’t think about the obstacles that might arise when you are chasing your dreams. You just take it for granted that one day, with enough resolve and dedication, and if you want it enough, you will obtain everything that you deserve.</p>
<p class="subsq">And as I look out at the stunning panoramic sea view from the rear deck of Coastguard’s Cottage, I know I’ve obtained everything I deserve. Sure, there have been obstacles along the way, some considerably bigger than others, but nothing I couldn’t handle. I’m a person who strongly believes in the power of desire. Desire drives some people more than others, and I’ve been driven very strongly by mine.</p>
<p class="subsq">A cottage by the sea, with a couple of kids running around in the garden, maybe playing with a hose, and the knowledge that I got here off my own back, not letting anything or anyone get in my way? Yeah, I guess that’s what I’ve always secretly wanted. And who cares that I don’t have a partner to share it with? As the old saying goes, there are plenty more fish in the sea! And I live so very close to the sea now.</p>
<p class="subsq">What’s that? Do I regret some of the things I’ve had to do to land this little slice of heaven? Not really. Because it’s what I deserve, you see? It was my destiny to end up here, in the delightful little town of Treme-on-Sea, in this amazing little cottage by the beach, with two precious kids running around and blossoming before my very eyes.</p>
<p class="subsq">It’s really something for a person to be able to say they have everything in life that they desire. How many people truly get to say that? I know there will be questions raised, judgements passed, suspicions aired, but I’ve covered my tracks well. So well that there’s zero chance of any blowback. How could there be? All the loose ends have been tied up.</p>
<p class="subsq">And if you had asked me, as that little kid playing on the beach all those years ago, ‘Would you be willing to make the ultimate sacrifice to get what you want? Would you be willing to kill to get it?’ I know exactly what my answer would have been.</p>
<p class="subsq"><i>You’re damn right I would.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?1480a378